/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Music_Notes_Surround_DoubleInputs */

const en_music_notes_surround_double = /** @type {(inputs: Music_Notes_Surround_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Surround Double (♪♪... ♪♪)`)
};

const fr_music_notes_surround_double = /** @type {(inputs: Music_Notes_Surround_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encadrer double (♪♪... ♪♪)`)
};

const de_music_notes_surround_double = /** @type {(inputs: Music_Notes_Surround_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Surround Double (♪♪... ♪♪)`)
};

const it_music_notes_surround_double = /** @type {(inputs: Music_Notes_Surround_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doppio surround (♪♪... ♪♪)`)
};

const ru_music_notes_surround_double = /** @type {(inputs: Music_Notes_Surround_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Двойной объемный звук (♪♪... ♪♪)`)
};

const es_music_notes_surround_double = /** @type {(inputs: Music_Notes_Surround_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doble envolvente (♪♪... ♪♪)`)
};

const zh_cn2_music_notes_surround_double = /** @type {(inputs: Music_Notes_Surround_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`环绕双音效 (♪♪... ♪♪)`)
};

const ja_music_notes_surround_double = /** @type {(inputs: Music_Notes_Surround_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サラウンドダブル（♪♪…♪♪）`)
};

const hi_music_notes_surround_double = /** @type {(inputs: Music_Notes_Surround_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सराउंड डबल (♪♪... ♪♪)`)
};

const pt_pt2_music_notes_surround_double = /** @type {(inputs: Music_Notes_Surround_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Surround Duplo (♪♪... ♪♪)`)
};

/**
* | output |
* | --- |
* | "Surround Double (♪♪... ♪♪)" |
*
* @param {Music_Notes_Surround_DoubleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const music_notes_surround_double = /** @type {((inputs?: Music_Notes_Surround_DoubleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Music_Notes_Surround_DoubleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_music_notes_surround_double(inputs)
	if (locale === "de") return de_music_notes_surround_double(inputs)
	if (locale === "it") return it_music_notes_surround_double(inputs)
	if (locale === "ru") return ru_music_notes_surround_double(inputs)
	if (locale === "es") return es_music_notes_surround_double(inputs)
	if (locale === "zh-CN") return zh_cn2_music_notes_surround_double(inputs)
	if (locale === "ja") return ja_music_notes_surround_double(inputs)
	if (locale === "hi") return hi_music_notes_surround_double(inputs)
	if (locale === "pt-PT") return pt_pt2_music_notes_surround_double(inputs)
	return en_music_notes_surround_double(inputs)
});